/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';

import AirBaloonIcon from '@/assets/images/icons/AirBaloonIcon';
import CartIcon from '@/assets/images/icons/CartIcon';
import ChartIcon from '@/assets/images/icons/ChartIcon';
import FourIcon from '@/assets/images/icons/FourIcon';
import MoneyExchangeIcon from '@/assets/images/icons/MoneyExchangeIcon';
import MoneyMoveIcon from '@/assets/images/icons/MoneyMoveIcon';
import MoneyShineImg from '@/assets/images/money_shine_img.webp';
import InternationalIcon from '@/assets/images/Online.svg';
import { BigTitle, BodyText, Caption, Title } from '@/components';

function LandingInvestBenefits() {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const benefits = [
    {
      icon: <ChartIcon />,
      caption:
        'В процессе заказа карты вы откроете брокерский счёт во Freedom Finance Global PLC и аккаунт в приложении Tradernet'
    },

    { icon: <FourIcon />, caption: 'Карта привязана к 4 неторговым счетам и отражает их баланс' },
    {
      icon: <img src={InternationalIcon} alt='' tw='sm:w-[80px] w-[52px]' />,
      caption: 'У каждого счёта — свой IBAN для межбанковских переводов'
    },
    { icon: <MoneyMoveIcon />, caption: 'Разные способы пополнения карты и вывода денег' },
    { icon: <MoneyExchangeIcon />, caption: 'Пополнение карты и конвертации — без комиссий' },
    { icon: <CartIcon />, caption: 'Оплаты по всему миру и в интернете — без комиссий' },
    {
      icon: <AirBaloonIcon />,
      caption: <span>Получение пластиковой карты в любом отделении банка</span>
    }
  ];
  return (
    <>
      <div>
        <BigTitle
          text={'Карта для инвестирования и покупок'}
          twStyle={tw`sm:text-[34px] text-[24px] text-[#70FF6E] sm:mb-20 mb-10`}
        />
        <div tw='sm:grid flex flex-col grid-cols-[2.1fr 1fr 1fr] gap-5'>
          {benefits.map(
            (card, index) =>
              index < 3 && (
                <div tw='bg-[#444444] rounded-[20px] p-5 pt-2 flex flex-col sm:gap-5 gap-0' key={card.caption + index}>
                  <div tw='h-[80px] flex items-center '>{card.icon}</div>
                  <BodyText text={card.caption} twStyle={tw``} />
                </div>
              )
          )}
        </div>
        <div tw='sm:grid flex flex-col grid-cols-4 gap-5 mt-5'>
          {benefits.map(
            (card, index) =>
              index > 2 && (
                <div tw='bg-[#444444] rounded-[20px] p-5 pt-2 flex flex-col sm:gap-5 gap-0' key={card.caption + index}>
                  <div tw='h-[80px] flex items-center '>{card.icon}</div>
                  <BodyText text={card.caption} twStyle={tw``} />
                </div>
              )
          )}
        </div>
        <div tw='bg-[#444444] rounded-[20px] p-5 pt-2 flex sm:flex-row flex-col-reverse mt-5 sm:w-[65%]'>
          <div tw='flex flex-col gap-5 pt-5 '>
            <Title text={'3% годовых в долларах на остаток'} twStyle={tw`text-[#70FF6E]`} variant={'bold'} />
            <BodyText
              text={
                'Freedom Finance Global PLC ежедневно начисляет вознаграждение на остаток накопительного (D) счёта.'
              }
            />
            <Caption
              text={'Компания не является участником Казахстанского фонда гарантирования депозитов'}
              twStyle={tw`text-secondary`}
            />
          </div>
          <img src={MoneyShineImg} alt='design' tw='sm:w-[100%] w-[150px] sm:ml-0 -ml-5' />
        </div>
      </div>
    </>
  );
}

export default LandingInvestBenefits;
